


























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CIpfTableForObligation from '@/modules/budget/execution/form/tabs/components/IpfTableForObligation.vue';
import CIpfTableForPayment from '@/modules/budget/execution/form/tabs/components/IpfTableForPayment.vue';
import CIpfAddItemModal from '@/modules/budget/execution/form/tabs/components/IpfAddItemModal.vue';
import popUp from '@/modules/budget/execution/form/tabs/components/popUp.vue';
import axios from "axios";
import {makeToast} from "@/modules/budget/bip/bip-types";
import {Ax} from "@/utils";
import SpfImportFromFileModal from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfImportFromFileModal.vue';
import VueElementLoading from "vue-element-loading";
import i18nService from "@/services/i18n";
import {fabric} from "@amcharts/amcharts4/.internal/fabric/fabric";

@Component({
    computed: {
        fabric() {
            return fabric
        }
    },
    components: {
        'c-ipf-table-for-obligation': CIpfTableForObligation,
        'c-ipf-table-for-payment': CIpfTableForPayment,
        'c-ipf-add-item-modal': CIpfAddItemModal,
        'loading': VueElementLoading,
        SpfImportFromFileModal,
        'popup': popUp
    }
})
export default class CInsideWindow extends Vue {
    private addItemToogler(){
        this.showAddItemModal = !this.showAddItemModal
    }
    @Prop({
        required: true,
        default: false
    })
    private import_acces!: any;

    @Prop({
        required: true,
        default: null
    })
    private filter!: any;

    @Prop({
        required: true,
        default: false
    })
    private edit_access!: boolean;
    @Prop({
        required: true,
        default: false
    })
    private delete_access!: boolean;

    @Prop({
        required: false,
        default: null
    })
    private currentForm!: any;

    @Prop({
        required: true,
        default: null
    })
    private abp!: any;

    @Prop({
        required: true,
        default: null
    })
    private region!: any;

    @Prop({
        required: true,
        default: false
    })
    private isTransfert!: boolean;

    private progress: number | null = null;

    private filterPrg: any = null;
    private filterPpr: any = null;
    private filterSpf: any = null;

    private showObligation = true;
    private showPayment = true;
    private showAddItemModal = false
    private showImportFileModal:boolean = false;
    private importTypeTable:number = 1;
    private loading = false;

    private isLoad = false;
    private isSuccess = false;
    private isEmptyTotal = false;
    private checkMonth = [
        {
            key: 'january',
            check: 'january'
        },
        {
            key: 'february',
            check: 'checkFeb'
        },
        {
            key: 'march',
            check: 'checkMar'
        },
        {
            key: 'april',
            check: 'checkApr'
        },
        {
            key: 'may',
            check: 'checkMay'
        },
        {
            key: 'june',
            check: 'checkJun'
        },
        {
            key: 'july',
            check: 'checkJul'
        },
        {
            key: 'august',
            check: 'checkAug'
        },
        {
            key: 'september',
            check: 'checkSep'
        },
        {
            key: 'october',
            check: 'checkOct'
        },
        {
            key: 'november',
            check: 'checkNov'
        },
        {
            key: 'december',
            check: 'checkDec'
        }
    ]

    private beforeUpdate() {
        this.budgetFormObligation.forEach((row: any) => {
            row._rowVariant = 'info';
        });
        this.budgetFormPayment.forEach((row: any) => {
            row._rowVariant = 'info';
        });
    }

    private async chgFilter() {
        this.filterPrg = this.filter.prg
        this.filterPpr = this.filter.ppr
        this.filterSpf = this.filter.spf
        this.showAddItemModal = false
        this.expiredSpfList = []
        await this.loadSpfList()
        this.progress = 10;
        this.$emit('chgLoad', true);
        this.budgetFormObligation.splice(0);
        this.budgetFormPayment.splice(0);
        this.budgetFormObligationTotal = 0;
        this.budgetFormPaymentTotal = 0;
        await this.prepareFormObligation();
        this.progress = 50;
        await this.prepareFormPayment();
        this.progress = 100;
        if (this.expiredSpfList.length) {
            const m = "Внимание, присутствуют строки с неактуальными спецификами. Пожалуйста, удалите специфику(и) " + this.expiredSpfList.sort((a, b) => a - b).join(', ');
            this.makeToast('warning', 'Ошибка', m)
        }
        this.isEmptyTotal = (this.budgetFormPayment.length === 0 && this.budgetFormObligation.length === 0) || (this.budgetFormObligationTotal === 0 && this.budgetFormPaymentTotal === 0)
        this.$emit('chgLoad', false);
    }



    private budgetFormObligation: any = [];
    private budgetFormObligationTotal: any = 0;
    private budgetFormPayment: any = [];
    private budgetFormPaymentTotal: any = 0;

    private calcFlds =  [
        'plan',
        'deviation',
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december'
    ];

    private uniqueId: number = 0;
    private isInsideSpf: boolean = false;

    private async prepareFormObligation() {
        this.budgetFormObligation.splice(0);
        const dataOblig = await this.getData('obligation');
        if (dataOblig && dataOblig.length > 0) {
            dataOblig.sort((a: any, b: any) => a.prg - b.prg)
            for (const item of dataOblig) {
                this.createTable(item, 'obligation');
            }
        }
        this.budgetFormObligation = dataOblig
        this.budgetFormObligation.forEach((el: any, ind: number) => {
            this.budgetFormObligationTotal += el.plan;
        });
    } // подготовка отображения данных обязательств

    private async prepareFormPayment() {
        this.budgetFormPayment.splice(0);
        const dataPayment = await this.getData('payment');
        if (dataPayment && dataPayment.length > 0)    {
            dataPayment.sort((a: any, b: any) => a.prg - b.prg)
            for (const item of dataPayment) {
                this.createTable(item, 'payment');
            }
        }
        this.budgetFormPayment = dataPayment
        this.budgetFormPayment.forEach((el: any, ind: number) => {
            this.budgetFormPaymentTotal += el.plan;
        });
    } // подготовка отображения данных платежей

    private createTable(item: any, typeTable: string) {
        const that = this;
        Object.defineProperty(item, 'rowFlk1', {
            get: function () {
                return (parseFloat(item.plan) !== parseFloat(item.deviation) && !that.isEmptyTotal && !item.newSpec && !item.newPrg && !item.newPpr)
            }
        })
        this.$set(item, 'table', typeTable);
        this.$set(item, 'collapse', true);

        if (item) {
            if (item.type === 5) {
                item.selected_expenses = []
            }
        }
        if (item.type === 4 && (item.hasOwnProperty('spf_list') && item.spf_list && item.spf_list.length > 0)) {
            const newPpr = {
                ...item
            }
            newPpr.ppr = null
            newPpr.name_ru = null
            newPpr.type = 5
            newPpr.spf_list = Object.assign([], item.spf_list)
            newPpr.child_list = Object.assign([], item.spf_list)
            if (item.hasOwnProperty('child_list') && item.child_list && item.child_list.length) {
                item.child_list.splice(0, 0, newPpr)
            } else {
                item.child_list = [newPpr]
            }
            delete item.spf_list
        }
        if (item.type === 4) {
            item.child_list.sort((a: any, b: any) => a.ppr - b.ppr)
        }
        if (item.type === 5) {
            item.spf_list.sort((a: any, b: any) => a.spf - b.spf)
            item.child_list = item.spf_list
        }
        if (item.type === 6) {
            item.selected_expenses = []
            item.child_list = []
            if (item.hasOwnProperty('execution_child_list') && item.execution_child_list && item.execution_child_list.length) {
                item.child_list = item.execution_child_list
            }
            item.child_list.sort((a:any, b:any) => a.expense_code.localeCompare(b.expense_code))
        }

        this.calcFields(item, typeTable);
        if (typeTable === 'obligation') {
            this.templateDataForObligation(item);
        } else if (typeTable === 'payment') {
            this.templateData(item);
        }
        if (item.hasChild) {
            for (const ch of item.child_list) {
                if (item.type === 6) {
                    item.parent.selected_expenses.push(ch.expense_code)
                }
                Object.defineProperty(ch, 'parent', {
                    get: function () {
                        return item;
                    }
                });
                ch.type = item.type + 1;
                this.createTable(ch, typeTable);
            }
        }
    }

    private reSum(parent: any, field: string, typeTable: string) {
        let sum = 0;
        if (field[0] === '_') {
            field = field.replace('_', '');
        }
        for (const ch of parent.child_list) {
            if (ch.hasOwnProperty(field) && ch[field]) {
                sum += parseFloat(ch[field]);
            }
        }

        return parseFloat(sum.toFixed(1));
    } // пересчет суммы


    private calcFields(item: any, typeTable: string) {
        const that = this;
        if (item.type > 5) {
            for (const f of that.calcFlds) {
                item[`_${f}`] = item[f]
            }
        }
        Object.defineProperty(item, 'hasChild', {
            get: function () {
                return item.child_list && item.child_list.length
            }
        })
        this.calcFlds.forEach(field => {
            if (!item.hasOwnProperty(field) || item.type === 6) {
                if (field !== 'deviation') {
                    Object.defineProperty(item, field, {
                        get: function () {
                            if (item.type === 6 && (!item.hasChild)) {
                                return item[`_${field}`];
                            }
                            return that.reSum(item, `_${field}`, typeTable);
                        },
                        set: function (value) {
                            item[`_${field}`] = value;
                        }
                    });
                }
            }
        });
    }


    private templateData(dataItem: any) {
        Object.defineProperty(dataItem, 'checkFeb', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkMar', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkApr', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkMay', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkJun', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkJul', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkAug', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkSep', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkOct', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september) + parseFloat(dataItem.october);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkNov', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september) + parseFloat(dataItem.october)
                    + parseFloat(dataItem.november);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkDec', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september) + parseFloat(dataItem.october)
                    + parseFloat(dataItem.november) + parseFloat(dataItem.december);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'deviation', {
            get: function () {
                const sum = (parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june)
                    + parseFloat(dataItem.july) + parseFloat(dataItem.august) + parseFloat(dataItem.september)
                    + parseFloat(dataItem.october) + parseFloat(dataItem.november) + parseFloat(dataItem.december));
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
    }


    private templateDataForObligation(dataItem: any) {
        Object.defineProperty(dataItem, 'checkFeb', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkMar', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkApr', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkMay', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkJun', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkJul', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkAug', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkSep', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkOct', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september) + parseFloat(dataItem.october);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkNov', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september) + parseFloat(dataItem.october)
                    + parseFloat(dataItem.november);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'checkDec', {
            get: function () {
                const sum = parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june) + parseFloat(dataItem.july)
                    + parseFloat(dataItem.august) + parseFloat(dataItem.september) + parseFloat(dataItem.october)
                    + parseFloat(dataItem.november) + parseFloat(dataItem.december);
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
        Object.defineProperty(dataItem, 'deviation', {
            get: function () {
                const sum = (parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                    + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june)
                    + parseFloat(dataItem.july) + parseFloat(dataItem.august) + parseFloat(dataItem.september)
                    + parseFloat(dataItem.october) + parseFloat(dataItem.november) + parseFloat(dataItem.december));
                return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
            }
        });
    }

    private async getData(type: string) {
        let values = [];
        try {
            const queryString = {...this.filter, type: type};
            queryString.level = 'prg'
            const response = await axios.get('/api/budget-execution-pf-ipf/tree', {params: queryString});
            values = response.data;

            values.sort((a: any, b: any) => { return (a.prg - b.prg); });

            if (values.length === 0) {
                this.$emit('chgLoad', false);
                return [];
            }
            this.loadApplicationsTitle(this.filter.year);
            // values.sort((a: any, b: any) => (a.spf - b.spf > 0) ? 1 : -1);
            // eslint-disable-next-line consistent-return
            return values;
        } catch (error) {
            this.$emit('chgLoad', false);
            this.makeToast('danger', "Ошибка запроса", "Нет индивидуального плана финансирования за заданный период");
            return []
        }
    }

    private toggleShowObligation() {
        this.showObligation = !this.showObligation;
    }

    private toggleShowPayment() {
        this.showPayment = !this.showPayment;
    }

    private async deleteSpfRemote(row: any) {
        let deleted = false
        const path = '/api/budget-execution-pf-ipf'
        const item = Object.assign({}, this.filter);
        this.$set(item, 'id', row.id);
        this.$set(item, 'spf', row.spf);
        this.$set(item, 'gr', row.gr);
        this.$set(item, 'prg', row.prg);
        this.$set(item, 'ppr', row.ppr);
        this.$set(item, 'expense_code', row.expense_code);
        this.$set(item, 'form', row.form);
        this.$set(item, 'user_id', this.$store.state.user.sub);

        this.$set(item, 'january', row.january);
        this.$set(item, 'february', row.february);
        this.$set(item, 'march', row.march);
        this.$set(item, 'april', row.april);
        this.$set(item, 'may', row.may);
        this.$set(item, 'june', row.june);
        this.$set(item, 'july', row.july);
        this.$set(item, 'august', row.august);
        this.$set(item, 'september', row.september);
        this.$set(item, 'october', row.october);
        this.$set(item, 'november', row.november);
        this.$set(item, 'december', row.december);
        await axios.delete(path, {data: [item]})
            .then(response => {
                if (response.status === 200) deleted = true
            })
            .catch(error => {
                console.log('Error making delete request:', error.message);
            });
        return deleted
    }
    private findRowFromTree(row:any, table:any[]):any {
        const dict:Record<number, string> = {
            4: 'prg',
            5: 'ppr',
            6: 'spf',
            7: 'expense_code'
        }
        for (const ch of table) {
            if (ch.type < row.type) {
                if (ch[dict[ch.type]] === row[dict[ch.type]]) {
                    return this.findRowFromTree(row, ch.child_list)
                }
            } else {
                if (ch[dict[ch.type]] === row[dict[ch.type]]) {
                    return ch
                }
            }
        }
        return row;
    }

    private async deleteRecursive(obj:any, table:any[]) {

        if (obj.hasChild && obj.type === 5) {
            for (let i = 0; i < table.length; i++) {
                const deleted = await this.deleteSpfRemote(table[i]);
                if (deleted) {
                    table.splice(i, 1)
                    i--
                }
            }
        } else {
            for (const ch of obj.child_list) {
                await this.deleteRecursive(ch, obj.child_list)
            }
        }
    }
    private async deleteFromTable(data:any, table:any[]) {
        const dict:Record<number, string> = {
            4: 'prg',
            5: 'ppr',
            6: 'spf',
            7: 'expense_code'
        }

        if (data.type < 6) {
            if (data.type === 4) {
                this.deleteRecursive(data, table)
            } else {
                this.deleteRecursive(data, data.parent.child_list)
            }
        } else {
            let deleted = false;
            if (!data.newSpec) {
                deleted = await this.deleteSpfRemote(data)
            }
            if (deleted || data.newSpec) {
                for (let i = 0; i < data.parent.child_list.length; i++) {
                    const ch = data.parent.child_list[i]
                    if (ch[dict[ch.type]] === data[dict[ch.type]]) {
                        data.parent.child_list.splice(i, 1)
                        break
                    }
                }
            }
        }
    }

    private async deleteSpec(body: any) {
        const dataOblig:any = this.findRowFromTree(body['data'], this.budgetFormObligation)
        const dataPay:any = this.findRowFromTree(body['data'], this.budgetFormPayment)
        await this.deleteFromTable(dataOblig, this.budgetFormObligation)
        await this.deleteFromTable(dataPay, this.budgetFormPayment)
    }

    private spfList: any = [];
    private spfMap:string[] = []
    private expiredSpfList:any[] = []
    private async loadSpfList() {
        try {
            this.spfList = [];
            this.spfMap = [];
            const response = await fetch('/api-py/get-spf-list/' + this.filter.year)
                .then(response => response.json());
            this.spfList = response.list;
            this.spfMap = this.spfList.map((v:any) => v.spf)
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки loadSpfList', error.toString());
        }
    }

    private addNewPrg(item: any, parent: any, type: string, data_type = 4) {
        const table:any[] = parent.child_list
        const that = this;
        for (let i = 0; i < table.length; i++) {
            const el = table[i]
            if (
                (el.prg === item.prg && data_type === 4) ||
                (el.prg === item.prg && el.ppr === item.ppr && data_type === 5) ||
                (el.prg === item.prg && el.ppr === item.ppr && el.spf === item.spf && data_type === 6)
            ) {
                return el
            }
        }
        this.uniqueId++;
        const dict:any = {
            '4': 'prg_',
            '5': 'ppr_',
            '6': '',
            '7': 'spf_'
        }
        const prefixKey = (item.type === 7 && data_type === 6) ? item.type : data_type;
        const prefix = dict[prefixKey.toString()];
        const dataItem: any = {
            id: null,
            type: data_type,
            selectPrg: item.prg,
            newPrg: ((!item.isAutoFill) || item.newPrg) && data_type === 4,
            newPpr: ((!item.isAutoFill) || item.newPpr) && data_type === 5,
            newSpec: ((!item.isAutoFill) || item.newSpec) && data_type === 6,
            name_ru: item[`${prefix}name_ru`],
            parent_id: this.uniqueId,
            collapse: true,
            gr: item.gr,
            abp: item.abp,
            prg: item.prg,
            ppr: data_type > 4 && item.ppr? item.ppr: null,
            spf: data_type > 5? item.spf: null,
            form: null,
            expense_code: null,
            child_list: [],
            selected_expenses: []
        }
        if (data_type === 6) {
            dataItem.plan = item.plan ?? 0
            dataItem.deviation = item.deviation? item.deviation: 0
            dataItem.january = item.january? item.january: 0
            dataItem.february = item.february? item.february: 0
            dataItem.march = item.march? item.march: 0
            dataItem.april = item.april? item.april: 0
            dataItem.may = item.may? item.may: 0
            dataItem.june = item.june? item.june: 0
            dataItem.july = item.july? item.july: 0
            dataItem.august = item.august? item.august: 0
            dataItem.september = item.september? item.september: 0
            dataItem.october = item.october? item.october: 0
            dataItem.november = item.november? item.november: 0
            dataItem.december = item.december? item.december: 0
        }
        this.uniqueId++;
        dataItem.id = this.uniqueId;
        this.uniqueId++;
        this.calcFields(dataItem, type);
        if (type === 'obligation') {
            this.templateDataForObligation(dataItem);
        } else if (type === 'payment') {
            this.templateData(dataItem);
        }
        let lowIndex = table.length; // default to end
        for (let i = 0; i < table.length; i++) {
            const el = table[i];
            if (
                (data_type === 4 && dataItem.prg < el.prg) ||
                (data_type === 5 && dataItem.ppr < el.ppr) ||
                (data_type === 6 && dataItem.spf < el.spf)
            ) {
                lowIndex = i;
                break;
            }
        }
        Object.defineProperty(dataItem, 'rowFlk1', {
            get: function () {
                return (parseFloat(dataItem.plan) !== parseFloat(dataItem.deviation) && !that.isEmptyTotal && !dataItem.newSpec && !dataItem.newPrg && !dataItem.newPpr)
            }
        })
        Object.defineProperty(dataItem, 'parent', {
            get: function () {
                return parent;
            }
        });
        table.splice(lowIndex, 0, dataItem)
        if (dataItem.type !== 4) {
            if (dataItem.parent.collapse) {
                dataItem.parent.collapse = false;
            }
        }
        return dataItem
    }
    private async loadSpfDict(spfs: any[]) {
        const req = {
            abp: this.filter.abp,
            spf_list: spfs
        }
        let dict:any = {}
        await axios.post('/api-py/dict-ebk-spf-map', req).then(response => {
            dict = response.data
        })
        return dict
    }
    private addNewItems(items: any[], is_create:number = 0) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i]
            item.ppr = item.ppr ? item.ppr : null
            //oblig
            if ((!is_create) || is_create === 1) {
                const obligprogEl = this.addNewPrg(item, {child_list: this.budgetFormObligation}, 'obligation', 4)
                const obligsubProgEl = this.addNewPrg(item, obligprogEl, 'obligation', 5)
                const obligspfEl = this.addNewPrg(item, obligsubProgEl, 'obligation', 6)
                if (item.type === 7 && is_create === 1) {
                    this.add_delete_expenses(obligspfEl, 'obligation', [item])
                }
            }
            //payment
            if ((!is_create) || is_create === 2) {
                const progEl = this.addNewPrg(item, {child_list: this.budgetFormPayment}, 'payment', 4)
                const subProgEl = this.addNewPrg(item, progEl, 'payment', 5)
                const spfEl = this.addNewPrg(item, subProgEl, 'payment', 6)
                if (item.type === 7 && is_create === 2) {
                    this.add_delete_expenses(spfEl, 'payment', [item])
                }
            }
        }

    }

    private add_delete_expenses(spf:any, typeTable:string = 'obligation', source_table:any[] = []) {
        const parent = spf.parent
        const that = this
        for (const exp of source_table.length? source_table: this.expense_list) {

            if (exp.checked && !exp.disabled) {
                if (!spf.selected_expenses.includes(exp.expense_code)) {
                    spf.selected_expenses.push(exp.expense_code)
                    const expNode:any = Object.assign({}, exp)
                    this.uniqueId++;
                    expNode.id = this.uniqueId
                    expNode.parent_id = spf.id
                    expNode.spf = spf.spf
                    expNode.gr = spf.gr
                    expNode.newSpec = true
                    expNode.name_ru = exp.nameRu
                    expNode.name_kk = exp.nameKz
                    expNode.plan = exp.plan? exp.plan: 0
                    expNode.deviation = exp.deviation? exp.deviation: 0
                    expNode.january = exp.january? exp.january: 0
                    expNode.february = exp.february? exp.february: 0
                    expNode.march = exp.march? exp.march: 0
                    expNode.april = exp.april? exp.april: 0
                    expNode.may = exp.may? exp.may: 0
                    expNode.june = exp.june? exp.june: 0
                    expNode.july = exp.july? exp.july: 0
                    expNode.august = exp.august? exp.august: 0
                    expNode.september = exp.september? exp.september: 0
                    expNode.october = exp.october? exp.october: 0
                    expNode.november = exp.november? exp.november: 0
                    expNode.december = exp.december? exp.december: 0

                    Object.defineProperty(expNode, 'parent', {
                        get: function () {
                            return spf
                        }
                    });
                    Object.defineProperty(expNode, 'rowFlk1', {
                        get: function () {
                            return (parseFloat(expNode.plan) !== parseFloat(expNode.deviation) && !that.isEmptyTotal && !expNode.newSpec && !expNode.newPrg && !expNode.newPpr)
                        }
                    })
                    expNode.type = 7
                    // debugger
                    this.$set(expNode, 'collapse', true);
                    this.calcFields(expNode, typeTable)
                    if (typeTable === 'obligation') {
                        this.templateDataForObligation(expNode);
                    } else if (typeTable === 'payment') {
                        this.templateData(expNode);
                    }
                    let lowIndex = spf.child_list.length
                    for (let i = lowIndex; i < spf.child_list.length; i++) {
                        if (spf.child_list[i].expense_code >= expNode.expense_code) {
                            lowIndex = i
                            break
                        }
                    }
                    spf.child_list.splice(lowIndex, 0, expNode);
                    spf.collapse = false
                }
                if (!parent.selected_expenses.includes(exp.expense_code)) {
                    parent.selected_expenses.push(exp.expense_code)
                }
            } else {
                if (!exp.disabled) {
                    if (spf.selected_expenses.includes(exp.expense_code)) {
                        for (let i = 0; i < spf.child_list.length; i++) {
                            if (spf.child_list[i].expense_code === exp.expense_code) {
                                spf.child_list.splice(i, 1)
                            }
                        }
                        for (let i = 0; i < spf.selected_expenses.length; i++) {
                            if (spf.selected_expenses[i] === exp.expense_code) {
                                spf.selected_expenses.splice(i, 1)
                            }
                        }
                    }
                    if (parent.selected_expenses.includes(exp.expense_code)) {
                        for (let i = 0; i < parent.selected_expenses.length; i++) {
                            if (parent.selected_expenses[i] === exp.expense_code) {
                                parent.selected_expenses.splice(i, 1)
                            }
                        }
                    }
                }
            }
        }
    }
    private expense_checked() {
        const [prg, ppr, spf] = this.cur_exp_spf_idx
        const obligSpf:any = this.budgetFormObligation[prg].child_list[ppr].child_list[spf];
        const paymentSpf:any = this.budgetFormPayment[prg].child_list[ppr].child_list[spf];
        this.add_delete_expenses(obligSpf, 'obligation')
        this.add_delete_expenses(paymentSpf, 'payment')
        this.show_bip_modal = false;
    }
    private getLowestChildren(targetTable:any[], resTable:any[]) {


        const setName = (obj:any, parent:any) => {
            if (parent.type === 6) {
                obj[`spf_name_ru`] = parent['name_ru']
                setName(obj, parent.parent)
            } else {
                let prefix = ''
                if (parent.type === 4) {
                    prefix = 'prg_'
                } else if (parent.type === 5) {
                    prefix = 'ppr_'
                }
                obj[`${prefix}name_ru`] = parent['name_ru']
                if (parent.type === 4) {
                    return
                }
                setName(obj, parent.parent)
            }


        }
        for (const data of resTable) {
            if (data.type < 6 || data.hasChild) {
                this.getLowestChildren(targetTable, data.child_list)
            } else {
                const temp:any = Object.assign({'isAutoFill': true}, data)
                setName(temp, data.parent)
                if (temp.type === 7) {
                    temp.nameRu = temp.name_ru
                    temp.nameKz = temp.name_kk
                    temp.checked = true
                }
                targetTable.push(temp)
            }
        }
    }
    private deepCloneTree(tree:any[]) {
        return tree.map((node:any) => {
            const newNode = { ...node };
            if (newNode.hasChild) {
                newNode.child_list = this.deepCloneTree(newNode.children);
            }
            return newNode;
        });
    }
    private openModal(type:number = 1) {
        // type 1 => obligations => payments
        // type 2 => payments => obligations
        this.$bvModal.msgBoxConfirm(
            type === 1 ? 'Вы действительно хотите скопировать данные из обязательств в платежи?': 'Вы действительно хотите скопировать данные из платежей в обязательства?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'ДА',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    if (type === 1) {
                        this.budgetFormPayment.splice(0)
                        const sourceTable:any[] = []
                        this.getLowestChildren(sourceTable, this.budgetFormObligation)
                        this.addNewItems(sourceTable, 2)
                    } else if (type === 2) {
                        this.budgetFormObligation.splice(0)
                        const sourceTable:any[] = []
                        this.getLowestChildren(sourceTable, this.budgetFormPayment)
                        this.addNewItems(sourceTable, 1)
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    private expense_list:any[] = []
    private async load_expense_codes(spf:any, type:string = 'obligation') {
        this.expense_list = []
        const params: any = {
            region: this.currentForm.region,
            year: this.currentForm.year,
            abp: this.currentForm.abp,
            gu: this.currentForm.gu,
            prg: spf.prg,
            spf: spf.spf,
            type: type
        }
        if (spf.ppr) {
            params.ppr = spf.ppr
        }
        await axios.get(`/api/budget-execution-transfer/ipf`, {
            params: params
        }).then(resp => {
            this.expense_list = resp.data;
            const parent = spf.parent
            for (const exp of this.expense_list) {
                exp.ppr = exp.ppr ? exp.ppr : null
                const in_spf = spf.selected_expenses.includes(exp.expense_code)
                exp.checked = in_spf;
                // отзеркалить комент когда попросят сдлеать уникальными
                // exp.disabled = parent.selected_expenses.includes(exp.expense_code) && (!in_spf);
                exp.disabled = false;
            }
        })
        this.expense_list = [...this.expense_list]
    }

    private show_bip_modal:boolean = false;
    private cur_exp_spf:any = {}
    private cur_exp_spf_idx:number[] = []
    private async add_expense_code(spf:any, index:number[]) {
        await this.load_expense_codes(spf);
        this.cur_exp_spf_idx = index
        this.cur_exp_spf = spf
        this.show_bip_modal = true
    }

    private getItemToSave(row: any, errorObligation: any) {
        const item = Object.assign({}, this.filter);
        this.$set(item, 'id', row.id);
        this.$set(item, 'spf', row.spf);
        this.$set(item, 'gr', row.gr);
        this.$set(item, 'prg', row.prg);
        this.$set(item, 'ppr', row.ppr? row.ppr : null);
        this.$set(item, 'expense_code', row.expense_code);
        this.$set(item, 'form', row.form);
        this.$set(item, 'user_id', this.$store.state.user.sub);
        // if (parseFloat(row.deviation) === 0) {
        this.$set(item, 'january', row.january);
        this.$set(item, 'february', row.february);
        this.$set(item, 'march', row.march);
        this.$set(item, 'april', row.april);
        this.$set(item, 'may', row.may);
        this.$set(item, 'june', row.june);
        this.$set(item, 'july', row.july);
        this.$set(item, 'august', row.august);
        this.$set(item, 'september', row.september);
        this.$set(item, 'october', row.october);
        this.$set(item, 'november', row.november);
        this.$set(item, 'december', row.december);
        return item;
    }
    private loopThroug(data: any[]): boolean {
        let hasChanges = false;
        for (const el of data) {
            if (el.child_list?.length) {
                hasChanges = this.loopThroug(el.child_list) || hasChanges
            } else {
                hasChanges = hasChanges || el.hasChanges || el.newSpec
            }
            if (hasChanges) {
                return true
            }
        }
        return hasChanges
    }
    private beforeExit() {
        let hasChanges = false
        hasChanges = hasChanges || this.loopThroug(this.budgetFormObligation)
        hasChanges = hasChanges || this.loopThroug(this.budgetFormPayment)
        return hasChanges
    }
    private flk1Agreement() {
        const errorObligation = {
            error: false
        };
        const errorPayment = {
            error: false
        };
        let prgParent = this.budgetFormPayment[0]
        for (const [ind, row] of this.budgetFormPayment.entries()) {
            if (row.type === 4) prgParent = row
            // флк по сохранению на уровне родителя
            if (prgParent.plan !== prgParent.deviation && prgParent.plan) {
                errorPayment.error = true;
            }
        }
        for (const row of this.budgetFormObligation) {
            // флк по сохранению на уровне родителя
            if (row.type === 4) prgParent = row;
            if (prgParent.plan !== prgParent.deviation && prgParent.plan) {
                errorObligation.error = true;
            }
        }
        return {payment: errorPayment.error, obligation: errorObligation.error}
    }
    private flk2save(tree1:any[], tree2:any[]) { // false if error// true if not
        if (!Array.isArray(tree1) || !Array.isArray(tree2)) return false;
        if (tree1.length !== tree2.length) return false;

        // Sort by type-specific key to make sure order doesn't matter
        const keyByType:Record<number, string> = {
            4: 'prg',
            5: 'ppr',
            6: 'spf',
            7: 'expense_code'
        };

        for (let i = 0; i < tree1.length; i++) {
            const node1 = tree1[i];
            const node2 = tree2[i];

            if (node1.type !== node2.type) return false;

            const key = keyByType[node1.type];
            if (!key || node1[key] !== node2[key]) {
                return false;
            }

            // Recursively compare children (if exist)
            const c1 = Array.isArray(node1.child_list) ? node1.child_list : [];
            const c2 = Array.isArray(node2.child_list) ? node2.child_list : [];

            if (!this.flk2save(c1, c2)) return false;
        }

        return true
    }
    private async prepareForSave() {
        const isNegative = (val: any) => {
            for (const mon of this.checkMonth) {
                if (val[mon.key] < 0) {
                    this.$set(val, `${mon.check}Error`, true)
                    return true;
                } else {
                    this.$set(val, `${mon.check}Error`, false)
                }
            }
            return false
        }
        const obligationValues = [];
        const paymentValues = [];
        const errorObligation = {
            error: false
        };
        const errorPayment = {
            error: false
        };
        let negativeValueError = false;

        for (const prg of this.budgetFormObligation) {
            if (prg.plan !== prg.deviation && prg.plan) {
                errorObligation.error = true;
                // break;
            }
            for (const ppr of prg.child_list) {
                for (const spf of ppr.child_list) {
                    negativeValueError = isNegative(spf)
                    if (negativeValueError) {
                        this.makeToast('warning', 'Сообщение', 'Сохранение не возможно так как присутствуют отрицательные значения');
                        return this.isSuccess;
                    }
                    obligationValues.push(this.getItemToSave(spf, errorObligation));
                    for (const exp of spf.child_list) {
                        negativeValueError = isNegative(exp)
                        if (negativeValueError) {
                            this.makeToast('warning', 'Сообщение', 'Сохранение не возможно так как присутствуют отрицательные значения');
                            return this.isSuccess;
                        }
                        obligationValues.push(this.getItemToSave(exp, errorObligation));
                    }
                }
            }
        }

        let checkPayment = false;
        if (!this.flk2save(this.budgetFormObligation, this.budgetFormPayment)) {
            this.makeToast('warning', 'Сообщение', 'Данные не сохранены. Имеются расхождения по данным обязательств и платежей!');
            return;
        }
        let finPlanError = false;

        for (const [prgIdx, prg] of this.budgetFormPayment.entries()) {
            if (prg.plan !== prg.deviation && prg.plan) {
                errorPayment.error = true;
                // break;
            }
            for (const [pprIdx, ppr] of prg.child_list.entries()) {
                for (const [spfIdx, spf] of ppr.child_list.entries()) {
                    negativeValueError = isNegative(spf)
                    if (negativeValueError) {
                        this.makeToast('warning', 'Сообщение', 'Сохранение не возможно так как присутствуют отрицательные значения');
                        return this.isSuccess;
                    }
                    const obligRow:any = this.budgetFormObligation[prgIdx].child_list[pprIdx].child_list[spfIdx]
                    if (parseFloat(spf.january) > obligRow.january ||
                        parseFloat(spf.checkFeb) > obligRow.checkFeb ||
                        parseFloat(spf.checkMar) > obligRow.checkMar ||
                        parseFloat(spf.checkApr) > obligRow.checkApr ||
                        parseFloat(spf.checkMay) > obligRow.checkMay ||
                        parseFloat(spf.checkJun) > obligRow.checkJun ||
                        parseFloat(spf.checkJul) > obligRow.checkJul ||
                        parseFloat(spf.checkAug) > obligRow.checkAug ||
                        parseFloat(spf.checkSep) > obligRow.checkSep ||
                        parseFloat(spf.checkOct) > obligRow.checkOct ||
                        parseFloat(spf.checkNov) > obligRow.checkNov ||
                        parseFloat(spf.checkDec) > obligRow.checkDec) {
                        checkPayment = true;
                        for (const mon of this.checkMonth) {
                            if ((parseFloat(spf[mon.check]) > obligRow[mon.check])) {
                                this.$set(spf, `${mon.check}Error`, true)
                                this.$set(obligRow, `${mon.check}Error`, true)
                            } else {
                                this.$set(spf, `${mon.check}Error`, false)
                                this.$set(obligRow, `${mon.check}Error`, false)
                            }
                        }

                    }
                    if (parseFloat(spf.deviation) != obligRow.deviation) {
                        this.$set(spf, 'deviationError', true)
                        this.$set(obligRow, 'deviationError', true)
                        finPlanError = true;
                    } else {
                        this.$set(spf, 'deviationError', false)
                        this.$set(obligRow, 'deviationError', false)
                    }
                    paymentValues.push(this.getItemToSave(spf, errorPayment));
                    //--------------------------------------------------------
                    for (const [expIdx, exp] of spf.child_list.entries()) {
                        negativeValueError = isNegative(exp)
                        if (negativeValueError) {
                            this.makeToast('warning', 'Сообщение', 'Сохранение не возможно так как присутствуют отрицательные значения');
                            return this.isSuccess;
                        }
                        const obligRow:any = this.budgetFormObligation[prgIdx].child_list[pprIdx].child_list[spfIdx].child_list[expIdx]
                        if (parseFloat(exp.january) > obligRow.january ||
                            parseFloat(exp.checkFeb) > obligRow.checkFeb ||
                            parseFloat(exp.checkMar) > obligRow.checkMar ||
                            parseFloat(exp.checkApr) > obligRow.checkApr ||
                            parseFloat(exp.checkMay) > obligRow.checkMay ||
                            parseFloat(exp.checkJun) > obligRow.checkJun ||
                            parseFloat(exp.checkJul) > obligRow.checkJul ||
                            parseFloat(exp.checkAug) > obligRow.checkAug ||
                            parseFloat(exp.checkSep) > obligRow.checkSep ||
                            parseFloat(exp.checkOct) > obligRow.checkOct ||
                            parseFloat(exp.checkNov) > obligRow.checkNov ||
                            parseFloat(exp.checkDec) > obligRow.checkDec) {
                            checkPayment = true;
                            for (const mon of this.checkMonth) {
                                if ((parseFloat(exp[mon.check]) > obligRow[mon.check])) {
                                    this.$set(exp, `${mon.check}Error`, true)
                                    this.$set(obligRow, `${mon.check}Error`, true)
                                } else {
                                    this.$set(exp, `${mon.check}Error`, false)
                                    this.$set(obligRow, `${mon.check}Error`, false)
                                }
                            }

                        }
                        if (parseFloat(exp.deviation) != obligRow.deviation) {
                            this.$set(exp, 'deviationError', true)
                            this.$set(obligRow, 'deviationError', true)
                            finPlanError = true;
                        } else {
                            this.$set(exp, 'deviationError', false)
                            this.$set(obligRow, 'deviationError', false)
                        }
                        paymentValues.push(this.getItemToSave(exp, errorPayment));
                    }
                }
            }
        }

        if (checkPayment || finPlanError) {
            if (checkPayment) this.makeToast('danger', 'Ошибка', 'Данные не сохранены. Сумма планов по платежам за период с начала года превышает сумму планов по обязательствам.');
            if (finPlanError) this.makeToast('danger', 'Ошибка', 'Данные не сохранены. Годовая сумма по обязательствам не равна годовой сумме по платежам.');
            return this.isSuccess;
        }
        if (obligationValues.length > 0) {
            if (errorObligation.error) {
                this.makeToast('warning', 'Сообщение', 'Имеются расхождения сумм по обязательствам и бюджетным заявкам');
            }
            await this.save(obligationValues, 'obligation', false, false);
        }
        // else {
        //     this.makeToast('warning', 'Сообщение', 'Данные не сохранены по обязательствам');
        // }

        if (paymentValues.length > 0) {
            if (errorPayment.error) {
                this.makeToast('warning', 'Сообщение', 'Имеются расхождения сумм по платежам и бюджетным заявкам');
            }
            await this.save(paymentValues, 'payment', false, false);
        }
        // else {
        //     this.makeToast('warning', 'Сообщение', 'Данные не сохранены по платежам');
        // }
        if (this.isSuccess) {
            this.makeToast('success', 'Сообщение', 'Данные сохранены!');
        }
        return this.isSuccess;
    }
    private flk0agr() {
        let total = 0
        for (const el of this.budgetFormPayment) {
            if (el.type === 4) {
                total += el.deviation
            }
        }
        return total > 0
    }

    private async save(values: any, typeTable: string, errorObligation = false, errorPayment = false) {
        this.isLoad = true;
        try {
            // const response = await fetch('/api-py/save-budget-execution-ipf/' + typeTable, {
            const response = await fetch('/api/budget-execution-pf-ipf/' + typeTable, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(values)
            });
            if (response.status === 200) {
                if (errorObligation && errorPayment) {
                    if (typeTable === 'obligation') {
                        this.makeToast('danger', 'Сообщение', 'Ошибочно введенные данные не были сохранены по обязательствам');
                    } else if (typeTable === 'payment') {
                        this.makeToast('danger', 'Сообщение', 'Ошибочно введенные данные не были сохранены по платежам');
                    }
                } else {
                    if (typeTable === 'obligation') {
                        // this.makeToast('success', 'Сообщение', 'Данные сохранены по обязательствам');
                        this.budgetFormObligation.splice(0);
                        this.budgetFormObligationTotal = 0;
                        await this.prepareFormObligation();
                    } else if (typeTable === 'payment') {
                        // this.makeToast('success', 'Сообщение', 'Данные сохранены по платежам');
                        this.budgetFormPayment.splice(0);
                        this.budgetFormPaymentTotal = 0;
                        await this.prepareFormPayment();
                    }
                    this.isSuccess = true;
                }
            } else {
                throw 'Ошибка сохранения данных. Возможно не все обязательные поля заполнены';
            }
        } catch (e) {
            this.makeToast('danger', 'Предупреждение', e.toString());
        } finally {
            this.isLoad = false;
        }
    } // сохранение данных

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

    private async downloadApplication(app: number) {
        this.loading = true;
        let d = {};
        let app_name = ''
        const dat: any = this.$refs.ipf
        const lang = this.$i18n.locale;
        const date = this.currentForm.create_date ? new Date(this.currentForm.create_date).toISOString().slice(0, 10) : null
        d = {
            'year': this.currentForm.year,
            'signers': [],
            'abp': this.currentForm.abp,
            'gu': this.currentForm.gu,
            'id': this.currentForm.id,
            'region_name': this.region.name_ru,
            'region_name_kz': this.region.name_kk,
            'abp_name': this.abp.name_ru,
            'abp_name_kz': this.abp.name_kk,
            'region': this.currentForm.region,
            'gr': this.filter.curGr,
            'prg': this.filter.prg ? this.filter.prg : 0,
            'ppr': this.filter.ppr ? this.filter.ppr : 0,
            'spf': this.filter.spf ? this.filter.spf : 0,
            'app': app,
            'treeData': [],
            'lang': lang,
            'isTransfert': this.isTransfert,
            'date': date
        }
        if (app === 22) {
            app_name = `Приложение ${app} ${this.currentForm.gu}_${this.currentForm.year} ${lang === 'kk' ? '( каз )' : '( рус )'}.xlsx`
        } else {
            app_name = `Приложение ${app}_${this.currentForm.gu}_${this.currentForm.year}.xlsx`
        }
        Ax(
            {
                url: '/api-py/get-budget-execution-report/',
                method: 'POST',
                responseType: 'blob',
                data: d
            },
            (data: any) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', app_name);
                document.body.appendChild(link);
                link.click();
                this.loading = false;

            },
            (error: any) => {
                this.makeToast('danger', 'Ошибка запроса downloadApplication()', error.toString());
                this.loading = false;
            }
        )
    }

    private importSpf(type:number=1) {
        this.showImportFileModal = true
        this.importTypeTable = type
    }
    private get obligationsImportPopUp() {
        return this.budgetFormObligation.length > 0
    }

    private get paymentsImportPopUp() {
        return this.budgetFormPayment.length > 0
    }
    private async clearTree() {
        this.$bvModal.msgBoxConfirm(
            'Вы хотите удалить данные безвозвратно?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'ДА',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(async (value:any) => {
                if (value) {
                    const deleteItems:any = {}
                    const path = '/api/budget-execution-pf-ipf'
                    for (const prg of this.budgetFormObligation) {
                        for (const ppr of prg.child_list) {
                            for (const row of ppr.child_list) {
                                const item = Object.assign({}, this.filter);
                                this.$set(item, 'id', row.id);
                                this.$set(item, 'spf', row.spf);
                                this.$set(item, 'gr', row.gr);
                                this.$set(item, 'prg', row.prg);
                                this.$set(item, 'ppr', row.ppr);
                                this.$set(item, 'expense_code', row.expense_code);
                                this.$set(item, 'form', row.form);
                                this.$set(item, 'user_id', this.$store.state.user.sub);

                                this.$set(item, 'january', row.january);
                                this.$set(item, 'february', row.february);
                                this.$set(item, 'march', row.march);
                                this.$set(item, 'april', row.april);
                                this.$set(item, 'may', row.may);
                                this.$set(item, 'june', row.june);
                                this.$set(item, 'july', row.july);
                                this.$set(item, 'august', row.august);
                                this.$set(item, 'september', row.september);
                                this.$set(item, 'october', row.october);
                                this.$set(item, 'november', row.november);
                                this.$set(item, 'december', row.december);
                                deleteItems[`${item.abp}_${item.gu}_${item.prg}_${item.ppr}_${item.spf}_${item.expense_code}`] = item
                            }
                        }
                    }
                    for (const prg of this.budgetFormPayment) {
                        for (const ppr of prg.child_list) {
                            for (const row of ppr.child_list) {
                                const item = Object.assign({}, this.filter);
                                this.$set(item, 'id', row.id);
                                this.$set(item, 'spf', row.spf);
                                this.$set(item, 'gr', row.gr);
                                this.$set(item, 'prg', row.prg);
                                this.$set(item, 'ppr', row.ppr);
                                this.$set(item, 'expense_code', row.expense_code);
                                this.$set(item, 'form', row.form);
                                this.$set(item, 'user_id', this.$store.state.user.sub);

                                this.$set(item, 'january', row.january);
                                this.$set(item, 'february', row.february);
                                this.$set(item, 'march', row.march);
                                this.$set(item, 'april', row.april);
                                this.$set(item, 'may', row.may);
                                this.$set(item, 'june', row.june);
                                this.$set(item, 'july', row.july);
                                this.$set(item, 'august', row.august);
                                this.$set(item, 'september', row.september);
                                this.$set(item, 'october', row.october);
                                this.$set(item, 'november', row.november);
                                this.$set(item, 'december', row.december);
                                deleteItems[`${item.abp}_${item.gu}_${item.prg}_${item.ppr}_${item.spf}_${item.expense_code}`] = item
                            }
                        }
                    }

                    await axios.delete(path, {data: Object.values(deleteItems)})
                        .then(response => {
                            if (response.status === 200) {
                                this.budgetFormPayment = []
                                this.budgetFormObligation = []
                                this.budgetFormObligationTotal = 0
                                this.budgetFormPaymentTotal = 0
                                this.makeToast('info', 'Удаление', 'Данные успешно удалены!')
                            }
                        })
                        .catch(error => {
                            this.makeToast('danger', 'Удаление', 'Не далось вернуть данные!')
                        });
                }
            })
            .catch(error => {
                console.log(error);
            });

    }

    private async imortObligations(data:any) {
        if (this.budgetFormObligation.length) {
            this.makeToast('danger', 'Импорт', 'Таблицы не очищены')
            return
        }
        const arrData = data.plan;
        const error:any = data.error
        if (error.incorrectRows) {
            this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию и исправьте ошибки.')
        }
        if (error.negativeValue) {
            this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию присутствуют отрицательные значения')
            return
        }
        if (error.duplicationError) {
            const duplicates:any[] = error.duplicates;
            const text = duplicates.map(val => `${val.prg}->${val.ppr}->${val.spf}`).join('\n')
            this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию присутствуют дубли')
            return
        }
        if (!arrData.length) {
            this.makeToast('danger', 'Импорт', 'Пустая таблица. Пожалуйста, добавьте данные.')
            return
        }
        this.addNewItems(arrData, 1)
    }
    private async imortPayments(data:any) {
        if (this.budgetFormPayment.length) {
            this.makeToast('danger', 'Импорт', 'Таблицы не очищены')
            return
        }
        const arrData = data.plan;
        const error:any = data.error
        if (error.incorrectRows) {
            this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию и исправьте ошибки.')
        }
        if (error.negativeValue) {
            this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию присутствуют отрицательные значения')
            return
        }
        if (error.duplicationError) {
            const duplicates:any[] = error.duplicates;
            const text = duplicates.map(val => `${val.prg}->${val.ppr}->${val.spf}`).join('\n')
            this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию присутствуют дубли')
            return
        }
        if (!arrData.length) {
            this.makeToast('danger', 'Импорт', 'Пустая таблица. Пожалуйста, добавьте данные.')
            return
        }
        this.addNewItems(arrData, 2)
    }

    private infoModule(info_id:any, file:any) {
        const that = this;
        Ax(
            {
                url: '/api-py/get-info/' + info_id, //  Тело файла
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data:any) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file + '.pdf');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error:any) => {
                this.makeToast('danger', 'Ошибка загрузки', error.toString());
            }
        );
    }

    private ipfList = [];

    private async loadApplicationsTitle(curYear: number) {
        if (typeof curYear !== 'number') {
            return
        }
        try {
            const date = `${curYear}-01-01`
            const response = await axios.get(`/api-py/budget_execution_applications-list/${date}`);
            this.ipfList = response.data.sort((a: any, b: any) => a.id - b.id) || [];

        } catch (error) {
            console.error('Ошибка при загрузке списка приложений', error);
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить список приложений');
        }
    }

    private appText(app: any) {
        switch (`${i18nService.locale}`) {
            case 'ru':
                return `${app.name_ru} ${app.full_name_ru}`
            case 'kk':
                return `${app.name_kz} ${app.full_name_kz}`
            case 'en':
                return `${app.name_ru} ${app.full_name_ru}`
            default:
                break;
        }
    }

}
